export const DASHBOARD_MOCK_DATA = [
    {
        month: "01/2024",
        gross: 24804.13,
        cogs: 4213.86,
        perc_cogs: "evaluating...",
        labor: 48559.29,
        perc_labor: "evaluating...",
        netincome: -63234.93,
        intexp: 0,
        taxexp: 0,
        deprexp: 0,
        amrexp: 0,
        ebitda: -63234.93,
        ebitdaperc: -254.94,
        transnum: 40,
        avg: 620.10
    },
    {
        month: "02/2024",
        gross: 42167.33,
        cogs: 10773.63,
        perc_cogs: ((10773.63 / 42167.33) * 100).toFixed(2),
        labor: 50364.15,
        perc_labor: ((50364.15 / 42167.33) * 100).toFixed(2),
        netincome: -52605.26,
        intexp: 0,
        taxexp: 0,
        deprexp: 0,
        amrexp: 0,
        ebitda: -52605.26,
        ebitdaperc: -124.75,
        transnum: 79,
        avg: 533.76
    }
];

export const DASHBOARD_MOCK_DATA_QUARTERLY = [
    {
        sumqtr: "Q1",
        gross: 117211.03,
        cogs: 22327.89,
        perc_cogs: ((22327.89 / 117211.03) * 100).toFixed(2),
        labor: 148032.67,
        perc_labor: ((148032.67 / 117211.03) * 100).toFixed(2),
        netincome: -151466.34,
        intexp: 0,
        taxexp: 0,
        deprexp: 0,
        amrexp: 0,
        ebitda: -151466.34,
        ebitdaperc: -129.23,
        transnum: 211,
        avg: 555.50
    }
];

export const DASHBOARD_MOCK_DATA_YTD = [
    {
        ytd: "2024",
        gross: 288789.55,
        cogs: 64278.39,
        perc_cogs: ((64278.39 / 288789.55) * 100).toFixed(2),
        labor: 328718.11,
        perc_labor: ((328718.11 / 288789.55) * 100).toFixed(2),
        netincome: -277887.91,
        intexp: 0,
        taxexp: 0,
        deprexp: 0,
        amrexp: 0,
        ebitda: -277887.91,
        ebitdaperc: -96.23,
        transnum: 580,
        avg: 491.91
    }
];

export const FULLPAYLOAD = {
    "info": {
        "id": "1",
        "syncToken": "24",
        "metaData": {
            "createdByRef": null,
            "createTime": "2023-05-11T02:58:55.000+00:00",
            "lastModifiedByRef": null,
            "lastUpdatedTime": "2024-09-16T15:29:59.000+00:00",
            "lastChangedInQB": null,
            "synchronized": null
        },
        "customField": [],
        "attachableRef": [],
        "domain": "QBO",
        "status": null,
        "sparse": false,
        "companyName": "Tell Tail Veterinary, Inc",
        "legalName": "Tell Tail Veterinary, Inc",
        "companyAddr": {
            "id": "2",
            "line1": "414 Encinitas Blvd",
            "line2": null,
            "line3": null,
            "line4": null,
            "line5": null,
            "city": "Encinitas",
            "country": "USA",
            "countryCode": null,
            "county": null,
            "countrySubDivisionCode": "CA",
            "postalCode": "92024-3790",
            "postalCodeSuffix": null,
            "lat": null,
            "tag": null,
            "note": null,
            "long": null
        },
        "customerCommunicationAddr": {
            "id": "551",
            "line1": "414 Encinitas Blvd",
            "line2": null,
            "line3": null,
            "line4": null,
            "line5": null,
            "city": "Encinitas",
            "country": "USA",
            "countryCode": null,
            "county": null,
            "countrySubDivisionCode": "CA",
            "postalCode": "92024-3790",
            "postalCodeSuffix": null,
            "lat": null,
            "tag": null,
            "note": null,
            "long": null
        },
        "legalAddr": {
            "id": "550",
            "line1": "414 Encinitas Blvd",
            "line2": null,
            "line3": null,
            "line4": null,
            "line5": null,
            "city": "Encinitas",
            "country": "USA",
            "countryCode": null,
            "county": null,
            "countrySubDivisionCode": "CA",
            "postalCode": "92024-3790",
            "postalCodeSuffix": null,
            "lat": null,
            "tag": null,
            "note": null,
            "long": null
        },
        "companyEmailAddr": null,
        "customerCommunicationEmailAddr": {
            "id": null,
            "address": "scoolidge@moonlightvet.com",
            "tag": null,
            "default": null
        },
        "companyURL": null,
        "primaryPhone": {
            "id": null,
            "deviceType": null,
            "countryCode": null,
            "areaCode": null,
            "exchangeCode": null,
            "extension": null,
            "freeFormNumber": "+17606525002",
            "tag": null,
            "default": null
        },
        "otherContactInfo": [],
        "companyFileName": null,
        "flavorStratum": null,
        "sampleFile": null,
        "companyUserId": null,
        "companyUserAdminEmail": null,
        "companyStartDate": "2023-05-10T07:00:00.000+00:00",
        "employerId": "87-1144580",
        "fiscalYearStartMonth": "JANUARY",
        "taxYearStartMonth": null,
        "country": "US",
        "shipAddr": null,
        "otherAddr": [],
        "mobile": null,
        "fax": null,
        "email": {
            "id": null,
            "address": "shad.halsey.rscpc@gmail.com",
            "tag": null,
            "default": null
        },
        "webAddr": {
            "id": null,
            "uri": "https://moonlightvet.com/",
            "tag": null,
            "default": null
        },
        "lastImportedTime": null,
        "lastSyncTime": null,
        "supportedLanguages": "en",
        "defaultTimeZone": null,
        "multiByteCharsSupported": null,
        "nameValue": [
            {
                "name": "NeoEnabled",
                "value": "true"
            },
            {
                "name": "NonTracking",
                "value": "false"
            },
            {
                "name": "IsQbdtMigrated",
                "value": "false"
            },
            {
                "name": "IndustryType",
                "value": "Veterinary Services"
            },
            {
                "name": "CompanyType",
                "value": "Corporation"
            },
            {
                "name": "IndustryCode",
                "value": "541940"
            },
            {
                "name": "SubscriptionStatus",
                "value": "SUBSCRIBED"
            },
            {
                "name": "OfferingSku",
                "value": "QuickBooks Online Plus"
            },
            {
                "name": "PayrollFeature",
                "value": "false"
            },
            {
                "name": "AccountantFeature",
                "value": "false"
            },
            {
                "name": "QBOIndustryType",
                "value": "Manufacturing Businesses"
            },
            {
                "name": "ItemCategoriesFeature",
                "value": "true"
            },
            {
                "name": "AssignedTime",
                "value": "2023-05-10T20:58:55-07:00"
            }
        ],
        "fifoCalculationStatus": null,
        "companyInfoEx": null,
        "qbversion": null
    },
    "ytd": {
        "TOTAL": {
            "label": "ytd",
            "startPeriod": "2024-01-01",
            "endPeriod": "2024-08-31",
            "gross": 2182265.32,
            "cogs": 420741.39,
            "percCogs": 19.29,
            "labor": 1567019.74,
            "percLabor": 71.81,
            "intExp": 11422.33,
            "taxExp": 10066.43,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": -270781.41,
            "ebidta": -249292.65,
            "ebidtaPerc": -11.43
        },
        "Not Specified": {
            "label": "ytd",
            "startPeriod": "2024-01-01",
            "endPeriod": "2024-08-31",
            "gross": 1765674.09,
            "cogs": 324598.98,
            "percCogs": 18.39,
            "labor": 1119520.17,
            "percLabor": 63.41,
            "intExp": 11422.33,
            "taxExp": 3374.79,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": 81458.44,
            "ebidta": 96255.56,
            "ebidtaPerc": 5.452
        },
        "Moonlight": {
            "label": "ytd",
            "startPeriod": "2024-01-01",
            "endPeriod": "2024-08-31",
            "gross": 416591.23,
            "cogs": 96142.41,
            "percCogs": 23.08,
            "labor": 447499.57,
            "percLabor": 107.5,
            "intExp": 0,
            "taxExp": 6691.64,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": -352239.85,
            "ebidta": -345548.21,
            "ebidtaPerc": -82.95
        }
    },
    "rolling12": {
        "TOTAL": {
            "label": "rolling12",
            "startPeriod": "2023-09-01",
            "endPeriod": "2024-08-31",
            "gross": 3179213.86,
            "cogs": 616346.7,
            "percCogs": 19.39,
            "labor": 2217228.48,
            "percLabor": 69.75,
            "intExp": 17418.01,
            "taxExp": 14632.41,
            "deprExp": 137355,
            "amrExp": 33857,
            "netIncome": -473098.03,
            "ebidta": -269835.61,
            "ebidtaPerc": -8.488
        },
        "Not Specified": {
            "label": "rolling12",
            "startPeriod": "2023-09-01",
            "endPeriod": "2024-08-31",
            "gross": 2747368.76,
            "cogs": 518578.13,
            "percCogs": 18.88,
            "labor": 1742463.58,
            "percLabor": 63.43,
            "intExp": 17418.01,
            "taxExp": 3374.79,
            "deprExp": 9130,
            "amrExp": 33857,
            "netIncome": 68022.54,
            "ebidta": 131802.34,
            "ebidtaPerc": 4.798
        },
        "Moonlight": {
            "label": "rolling12",
            "startPeriod": "2023-09-01",
            "endPeriod": "2024-08-31",
            "gross": 431845.1,
            "cogs": 97768.57,
            "percCogs": 22.64,
            "labor": 474764.9,
            "percLabor": 110,
            "intExp": 0,
            "taxExp": 11257.62,
            "deprExp": 128225,
            "amrExp": 0,
            "netIncome": -541120.57,
            "ebidta": -401637.95,
            "ebidtaPerc": -93.01
        }
    },
    "q1": {
        "TOTAL": {
            "label": "q1",
            "startPeriod": "2024-01-01",
            "endPeriod": "2024-03-31",
            "gross": 751278.21,
            "cogs": 128819.21,
            "percCogs": 17.15,
            "labor": 566740.12,
            "percLabor": 75.44,
            "intExp": 4449.85,
            "taxExp": 6691.64,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": -128853.78,
            "ebidta": -117712.29,
            "ebidtaPerc": -15.67
        },
        "Not Specified": {
            "label": "q1",
            "startPeriod": "2024-01-01",
            "endPeriod": "2024-03-31",
            "gross": 634135.27,
            "cogs": 104095.62,
            "percCogs": 16.42,
            "labor": 416907.45,
            "percLabor": 65.75,
            "intExp": 4449.85,
            "taxExp": 0,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": 25008.26,
            "ebidta": 29458.11,
            "ebidtaPerc": 4.646
        },
        "Moonlight": {
            "label": "q1",
            "startPeriod": "2024-01-01",
            "endPeriod": "2024-03-31",
            "gross": 117142.94,
            "cogs": 24723.59,
            "percCogs": 21.11,
            "labor": 149832.67,
            "percLabor": 128,
            "intExp": 0,
            "taxExp": 6691.64,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": -153862.04,
            "ebidta": -147170.4,
            "ebidtaPerc": -125.7
        }
    },
    "q2": {
        "TOTAL": {
            "label": "q2",
            "startPeriod": "2024-04-01",
            "endPeriod": "2024-07-31",
            "gross": 1166674.17,
            "cogs": 225932.05,
            "percCogs": 19.37,
            "labor": 818686.05,
            "percLabor": 70.18,
            "intExp": 5635.91,
            "taxExp": 3336.79,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": -86151.09,
            "ebidta": -77178.39,
            "ebidtaPerc": -6.616
        },
        "Not Specified": {
            "label": "q2",
            "startPeriod": "2024-04-01",
            "endPeriod": "2024-07-31",
            "gross": 932213.81,
            "cogs": 167432.06,
            "percCogs": 17.97,
            "labor": 574761.67,
            "percLabor": 61.66,
            "intExp": 5635.91,
            "taxExp": 3336.79,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": 82340.41,
            "ebidta": 91313.11,
            "ebidtaPerc": 9.796
        },
        "Moonlight": {
            "label": "q2",
            "startPeriod": "2024-04-01",
            "endPeriod": "2024-07-31",
            "gross": 234460.36,
            "cogs": 58499.99,
            "percCogs": 24.96,
            "labor": 243924.38,
            "percLabor": 104.1,
            "intExp": 0,
            "taxExp": 0,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": -168491.5,
            "ebidta": -168491.5,
            "ebidtaPerc": -71.87
        }
    },
    "q3": {
        "TOTAL": {
            "label": "q3",
            "startPeriod": "2024-07-01",
            "endPeriod": "2024-09-30",
            "gross": 590042.54,
            "cogs": 144358.07,
            "percCogs": 24.47,
            "labor": 491512.5,
            "percLabor": 83.31,
            "intExp": 2867.29,
            "taxExp": 38,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": -178540.62,
            "ebidta": -175635.33,
            "ebidtaPerc": -29.77
        },
        "Not Specified": {
            "label": "q3",
            "startPeriod": "2024-07-01",
            "endPeriod": "2024-09-30",
            "gross": 461841.67,
            "cogs": 114031.78,
            "percCogs": 24.7,
            "labor": 349192.09,
            "percLabor": 75.61,
            "intExp": 2867.29,
            "taxExp": 38,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": -79890.5,
            "ebidta": -76985.21,
            "ebidtaPerc": -16.67
        },
        "Moonlight": {
            "label": "q3",
            "startPeriod": "2024-07-01",
            "endPeriod": "2024-09-30",
            "gross": 128200.87,
            "cogs": 30326.29,
            "percCogs": 23.66,
            "labor": 142320.41,
            "percLabor": 111.1,
            "intExp": 0,
            "taxExp": 0,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": -98650.12,
            "ebidta": -98650.12,
            "ebidtaPerc": -76.95
        }
    },
    "q4": {
        "TOTAL": {
            "label": "q4",
            "startPeriod": "2024-10-01",
            "endPeriod": "2024-12-31",
            "gross": 0,
            "cogs": 0,
            "percCogs": 0,
            "labor": 0,
            "percLabor": 0,
            "intExp": 0,
            "taxExp": 0,
            "deprExp": 0,
            "amrExp": 0,
            "netIncome": 0,
            "ebidta": 0,
            "ebidtaPerc": 0
        }
    },
    "months": [
        {
            "TOTAL": {
                "label": "JANUARY",
                "startPeriod": "2024-01-01",
                "endPeriod": "2024-01-31",
                "gross": 238740.53,
                "cogs": 31629.18,
                "percCogs": 13.25,
                "labor": 184396.84,
                "percLabor": 77.24,
                "intExp": 1410.42,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -40737.19,
                "ebidta": -39326.77,
                "ebidtaPerc": -16.48
            },
            "Not Specified": {
                "label": "JANUARY",
                "startPeriod": "2024-01-01",
                "endPeriod": "2024-01-31",
                "gross": 213936.4,
                "cogs": 27415.32,
                "percCogs": 12.82,
                "labor": 135837.55,
                "percLabor": 63.5,
                "intExp": 1410.42,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": 22497.74,
                "ebidta": 23908.16,
                "ebidtaPerc": 11.18
            },
            "Moonlight": {
                "label": "JANUARY",
                "startPeriod": "2024-01-01",
                "endPeriod": "2024-01-31",
                "gross": 24804.13,
                "cogs": 4213.86,
                "percCogs": 16.99,
                "labor": 48559.29,
                "percLabor": 195.8,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -63234.93,
                "ebidta": -63234.93,
                "ebidtaPerc": -255
            }
        },
        {
            "TOTAL": {
                "label": "FEBRUARY",
                "startPeriod": "2024-02-01",
                "endPeriod": "2024-02-29",
                "gross": 249244.39,
                "cogs": 44492.87,
                "percCogs": 17.86,
                "labor": 189195.46,
                "percLabor": 75.91,
                "intExp": 1399.96,
                "taxExp": 6691.64,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -46150.39,
                "ebidta": -38058.79,
                "ebidtaPerc": -15.27
            },
            "Not Specified": {
                "label": "FEBRUARY",
                "startPeriod": "2024-02-01",
                "endPeriod": "2024-02-29",
                "gross": 207077.06,
                "cogs": 33719.24,
                "percCogs": 16.29,
                "labor": 137031.31,
                "percLabor": 66.18,
                "intExp": 1399.96,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": 6454.87,
                "ebidta": 7854.83,
                "ebidtaPerc": 3.794
            },
            "Moonlight": {
                "label": "FEBRUARY",
                "startPeriod": "2024-02-01",
                "endPeriod": "2024-02-29",
                "gross": 42167.33,
                "cogs": 10773.63,
                "percCogs": 25.55,
                "labor": 52164.15,
                "percLabor": 123.8,
                "intExp": 0,
                "taxExp": 6691.64,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -52605.26,
                "ebidta": -45913.62,
                "ebidtaPerc": -108.9
            }
        },
        {
            "TOTAL": {
                "label": "MARCH",
                "startPeriod": "2024-03-01",
                "endPeriod": "2024-03-31",
                "gross": 263293.29,
                "cogs": 52697.16,
                "percCogs": 20.02,
                "labor": 193147.82,
                "percLabor": 73.36,
                "intExp": 1639.47,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -41966.2,
                "ebidta": -40326.73,
                "ebidtaPerc": -15.32
            },
            "Not Specified": {
                "label": "MARCH",
                "startPeriod": "2024-03-01",
                "endPeriod": "2024-03-31",
                "gross": 213121.81,
                "cogs": 42961.06,
                "percCogs": 20.16,
                "labor": 144038.59,
                "percLabor": 67.59,
                "intExp": 1639.47,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -3944.35,
                "ebidta": -2304.88,
                "ebidtaPerc": -1.082
            },
            "Moonlight": {
                "label": "MARCH",
                "startPeriod": "2024-03-01",
                "endPeriod": "2024-03-31",
                "gross": 50171.48,
                "cogs": 9736.1,
                "percCogs": 19.41,
                "labor": 49109.23,
                "percLabor": 97.89,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -38021.85,
                "ebidta": -38021.85,
                "ebidtaPerc": -75.79
            }
        },
        {
            "TOTAL": {
                "label": "APRIL",
                "startPeriod": "2024-04-01",
                "endPeriod": "2024-04-30",
                "gross": 260745.59,
                "cogs": 48974.81,
                "percCogs": 18.79,
                "labor": 222348.54,
                "percLabor": 85.28,
                "intExp": 1378.96,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -55425.07,
                "ebidta": -54046.11,
                "ebidtaPerc": -20.73
            },
            "Not Specified": {
                "label": "APRIL",
                "startPeriod": "2024-04-01",
                "endPeriod": "2024-04-30",
                "gross": 219441.83,
                "cogs": 41662.37,
                "percCogs": 18.99,
                "labor": 164897.25,
                "percLabor": 75.15,
                "intExp": 1378.96,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -8355.17,
                "ebidta": -6976.21,
                "ebidtaPerc": -3.18
            },
            "Moonlight": {
                "label": "APRIL",
                "startPeriod": "2024-04-01",
                "endPeriod": "2024-04-30",
                "gross": 41303.76,
                "cogs": 7312.44,
                "percCogs": 17.71,
                "labor": 57451.29,
                "percLabor": 139.1,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -47069.9,
                "ebidta": -47069.9,
                "ebidtaPerc": -114
            }
        },
        {
            "TOTAL": {
                "label": "MAY",
                "startPeriod": "2024-05-01",
                "endPeriod": "2024-05-31",
                "gross": 300095.73,
                "cogs": 62608.92,
                "percCogs": 20.87,
                "labor": 178949.71,
                "percLabor": 59.64,
                "intExp": 1368.41,
                "taxExp": 2336.79,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": 4841.77,
                "ebidta": 8546.97,
                "ebidtaPerc": 2.849
            },
            "Not Specified": {
                "label": "MAY",
                "startPeriod": "2024-05-01",
                "endPeriod": "2024-05-31",
                "gross": 226009.8,
                "cogs": 35200.07,
                "percCogs": 15.58,
                "labor": 117574.33,
                "percLabor": 52.03,
                "intExp": 1368.41,
                "taxExp": 2336.79,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": 44584.62,
                "ebidta": 48289.82,
                "ebidtaPerc": 21.37
            },
            "Moonlight": {
                "label": "MAY",
                "startPeriod": "2024-05-01",
                "endPeriod": "2024-05-31",
                "gross": 74085.93,
                "cogs": 27408.85,
                "percCogs": 37,
                "labor": 61375.38,
                "percLabor": 82.85,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -39742.85,
                "ebidta": -39742.85,
                "ebidtaPerc": -53.65
            }
        },
        {
            "TOTAL": {
                "label": "JUNE",
                "startPeriod": "2024-06-01",
                "endPeriod": "2024-06-30",
                "gross": 294678.54,
                "cogs": 54925.81,
                "percCogs": 18.64,
                "labor": 187195.62,
                "percLabor": 63.53,
                "intExp": 1357.82,
                "taxExp": 1000,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -3880.77,
                "ebidta": -1522.95,
                "ebidtaPerc": -0.5169
            },
            "Not Specified": {
                "label": "JUNE",
                "startPeriod": "2024-06-01",
                "endPeriod": "2024-06-30",
                "gross": 238489.71,
                "cogs": 40711.59,
                "percCogs": 17.08,
                "labor": 125336.85,
                "percLabor": 52.56,
                "intExp": 1357.82,
                "taxExp": 1000,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": 42713.06,
                "ebidta": 45070.88,
                "ebidtaPerc": 18.9
            },
            "Moonlight": {
                "label": "JUNE",
                "startPeriod": "2024-06-01",
                "endPeriod": "2024-06-30",
                "gross": 56188.83,
                "cogs": 14214.22,
                "percCogs": 25.3,
                "labor": 61858.77,
                "percLabor": 110.1,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -46593.83,
                "ebidta": -46593.83,
                "ebidtaPerc": -82.93
            }
        },
        {
            "TOTAL": {
                "label": "JULY",
                "startPeriod": "2024-07-01",
                "endPeriod": "2024-07-31",
                "gross": 311154.31,
                "cogs": 59422.51,
                "percCogs": 19.1,
                "labor": 230192.18,
                "percLabor": 73.99,
                "intExp": 1530.72,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -31687.02,
                "ebidta": -30156.3,
                "ebidtaPerc": -9.692
            },
            "Not Specified": {
                "label": "JULY",
                "startPeriod": "2024-07-01",
                "endPeriod": "2024-07-31",
                "gross": 248272.47,
                "cogs": 49858.03,
                "percCogs": 20.09,
                "labor": 166953.24,
                "percLabor": 67.25,
                "intExp": 1530.72,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": 3397.9,
                "ebidta": 4928.62,
                "ebidtaPerc": 1.986
            },
            "Moonlight": {
                "label": "JULY",
                "startPeriod": "2024-07-01",
                "endPeriod": "2024-07-31",
                "gross": 62881.84,
                "cogs": 9564.48,
                "percCogs": 15.22,
                "labor": 63238.94,
                "percLabor": 100.6,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -35084.92,
                "ebidta": -35084.92,
                "ebidtaPerc": -55.8
            }
        },
        {
            "TOTAL": {
                "label": "AUGUST",
                "startPeriod": "2024-08-01",
                "endPeriod": "2024-08-31",
                "gross": 264312.94,
                "cogs": 65990.13,
                "percCogs": 24.97,
                "labor": 181593.57,
                "percLabor": 68.71,
                "intExp": 1336.57,
                "taxExp": 38,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -55776.54,
                "ebidta": -54401.97,
                "ebidtaPerc": -20.59
            },
            "Not Specified": {
                "label": "AUGUST",
                "startPeriod": "2024-08-01",
                "endPeriod": "2024-08-31",
                "gross": 199325.01,
                "cogs": 53071.3,
                "percCogs": 26.63,
                "labor": 127851.05,
                "percLabor": 64.15,
                "intExp": 1336.57,
                "taxExp": 38,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -25890.23,
                "ebidta": -24515.66,
                "ebidtaPerc": -12.3
            },
            "Moonlight": {
                "label": "AUGUST",
                "startPeriod": "2024-08-01",
                "endPeriod": "2024-08-31",
                "gross": 64987.93,
                "cogs": 12918.83,
                "percCogs": 19.88,
                "labor": 53742.52,
                "percLabor": 82.7,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -29886.31,
                "ebidta": -29886.31,
                "ebidtaPerc": -45.99
            }
        },
        {
            "TOTAL": {
                "label": "SEPTEMBER",
                "startPeriod": "2024-09-01",
                "endPeriod": "2024-09-30",
                "gross": 14575.29,
                "cogs": 18945.43,
                "percCogs": 130,
                "labor": 79726.75,
                "percLabor": 547,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -91077.06,
                "ebidta": -91077.06,
                "ebidtaPerc": -624.9
            },
            "Not Specified": {
                "label": "SEPTEMBER",
                "startPeriod": "2024-09-01",
                "endPeriod": "2024-09-30",
                "gross": 14244.19,
                "cogs": 11102.45,
                "percCogs": 77.95,
                "labor": 54387.8,
                "percLabor": 381.9,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -57398.17,
                "ebidta": -57398.17,
                "ebidtaPerc": -403
            },
            "Moonlight": {
                "label": "SEPTEMBER",
                "startPeriod": "2024-09-01",
                "endPeriod": "2024-09-30",
                "gross": 331.1,
                "cogs": 7842.98,
                "percCogs": 2369,
                "labor": 25338.95,
                "percLabor": 7653,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": -33678.89,
                "ebidta": -33678.89,
                "ebidtaPerc": -10180
            }
        },
        {
            "TOTAL": {
                "label": "OCTOBER",
                "startPeriod": "2024-10-01",
                "endPeriod": "2024-10-31",
                "gross": 0,
                "cogs": 0,
                "percCogs": 0,
                "labor": 0,
                "percLabor": 0,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": 0,
                "ebidta": 0,
                "ebidtaPerc": 0
            }
        },
        {
            "TOTAL": {
                "label": "NOVEMBER",
                "startPeriod": "2024-11-01",
                "endPeriod": "2024-11-30",
                "gross": 0,
                "cogs": 0,
                "percCogs": 0,
                "labor": 0,
                "percLabor": 0,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": 0,
                "ebidta": 0,
                "ebidtaPerc": 0
            }
        },
        {
            "TOTAL": {
                "label": "DECEMBER",
                "startPeriod": "2024-12-01",
                "endPeriod": "2024-12-31",
                "gross": 0,
                "cogs": 0,
                "percCogs": 0,
                "labor": 0,
                "percLabor": 0,
                "intExp": 0,
                "taxExp": 0,
                "deprExp": 0,
                "amrExp": 0,
                "netIncome": 0,
                "ebidta": 0,
                "ebidtaPerc": 0
            }
        }
    ]
}

export const EXPENSE_MODAL_DATA = {
    "7770 Bookkeeping Services": {"id": 237, "value": "7770 Bookkeeping Services", "payroll": true},
    "6800 Ancillary Products & Services Costs:6801 OTC Products, Shampoos, & Nutraceutical Costs": {
        "id": 150,
        "value": "6800 Ancillary Products & Services Costs:6801 OTC Products, Shampoos, & Nutraceutical Costs",
        "payroll": true
    },
    "7805 Client Reminders": {"id": 244, "value": "7805 Client Reminders", "payroll": false},
    "6000 Professional Services Costs": {"id": 19, "value": "6000 Professional Services Costs", "payroll": false},
    "7805 Direct Mailing": {"id": 243, "value": "7805 Direct Mailing", "payroll": false},
    "7715 Franchise Tax": {"id": 227, "value": "7715 Franchise Tax", "payroll": false},
    "7360 Business & Professional Book, Journals, VIN subscriptions": {
        "id": 273,
        "value": "7360 Business & Professional Book, Journals, VIN subscriptions",
        "payroll": true
    },
    "8000 Depreciation Expense": {"id": 254, "value": "8000 Depreciation Expense", "payroll": true},
    "6600 Anesthesia Costs": {"id": 148, "value": "6600 Anesthesia Costs", "payroll": true},
    "7515 Outside Storage": {"id": 202, "value": "7515 Outside Storage", "payroll": true},
    "7660 Utilities:7664 Water": {"id": 220, "value": "7660 Utilities:7664 Water", "payroll": false},
    "6500 Surgery Costs:6520 - Specialist Surgical Costs": {
        "id": 292,
        "value": "6500 Surgery Costs:6520 - Specialist Surgical Costs",
        "payroll": true
    },
    "8050 Amortization Expense": {"id": 255, "value": "8050 Amortization Expense", "payroll": false},
    "7450 Employee Recruitment": {"id": 198, "value": "7450 Employee Recruitment", "payroll": false},
    "7310 Employer Retirement Contribution Expense": {
        "id": 185,
        "value": "7310 Employer Retirement Contribution Expense",
        "payroll": false
    },
    "7809 Marketing Consultant Fees": {"id": 247, "value": "7809 Marketing Consultant Fees", "payroll": false},
    "7300 Employee Benefit Program Expense:7305 Group Term Life Insurance Premium Expense": {
        "id": 184,
        "value": "7300 Employee Benefit Program Expense:7305 Group Term Life Insurance Premium Expense",
        "payroll": false
    },
    "7365 Travel & Lodging Expense": {"id": 21, "value": "7365 Travel & Lodging Expense", "payroll": false},
    "7780 Employee Benefits Administration": {
        "id": 239,
        "value": "7780 Employee Benefits Administration",
        "payroll": false
    },
    "Reconciliation Discrepancies": {"id": 274, "value": "Reconciliation Discrepancies", "payroll": false},
    "7300 Employee Benefit Program Expense:7304 Group Disability Insurance Premium Expense": {
        "id": 183,
        "value": "7300 Employee Benefit Program Expense:7304 Group Disability Insurance Premium Expense",
        "payroll": false
    },
    "7300 Employee Benefit Program Expense": {
        "id": 178,
        "value": "7300 Employee Benefit Program Expense",
        "payroll": false
    },
    "7765 Accounting Fees": {"id": 236, "value": "7765 Accounting Fees", "payroll": false},
    "Uncategorized Expense": {"id": 288, "value": "Uncategorized Expense", "payroll": false},
    "9009 Income Tax Expense Account Series": {
        "id": 264,
        "value": "9009 Income Tax Expense Account Series",
        "payroll": false
    },
    "7130 Registered Veterinary Technicians Compensation": {
        "id": 161,
        "value": "7130 Registered Veterinary Technicians Compensation",
        "payroll": false
    },
    "7200 Employer Payroll Taxes Account Series Expenses": {
        "id": 177,
        "value": "7200 Employer Payroll Taxes Account Series Expenses",
        "payroll": false
    },
    "7500 Rent on Practice Real Estate": {"id": 17, "value": "7500 Rent on Practice Real Estate", "payroll": false},
    "7085 Veterinary Specialist - Contractor Payments": {
        "id": 158,
        "value": "7085 Veterinary Specialist - Contractor Payments",
        "payroll": false
    },
    "7400 Study Group Fees": {"id": 196, "value": "7400 Study Group Fees", "payroll": false},
    "7166 Bookkeeper Compensation": {"id": 169, "value": "7166 Bookkeeper Compensation", "payroll": false},
    "7755 Postage": {"id": 234, "value": "7755 Postage", "payroll": false},
    "6000 Professional Services Costs:6001 Vaccine Costs": {
        "id": 125,
        "value": "6000 Professional Services Costs:6001 Vaccine Costs",
        "payroll": true
    },
    "7660 Utilities": {"id": 22, "value": "7660 Utilities", "payroll": false},
    "7365 Travel & Lodging Expense:7368 Transportation": {
        "id": 194,
        "value": "7365 Travel & Lodging Expense:7368 Transportation",
        "payroll": true
    },
    "6825 Boarding Costs": {"id": 154, "value": "6825 Boarding Costs", "payroll": false},
    "7690 Rubbish Disposal": {"id": 226, "value": "7690 Rubbish Disposal", "payroll": false},
    "9040 Miscellaneous Expense": {"id": 260, "value": "9040 Miscellaneous Expense", "payroll": false},
    "7320 Professional Liability Insurance Premium Expense": {
        "id": 186,
        "value": "7320 Professional Liability Insurance Premium Expense",
        "payroll": false
    },
    "7520 Maintenance:7522 IT and Office Equipment Maintenance": {
        "id": 204,
        "value": "7520 Maintenance:7522 IT and Office Equipment Maintenance",
        "payroll": true
    },
    "6100 Pharmacy Costs:6110 Injection Costs": {
        "id": 133,
        "value": "6100 Pharmacy Costs:6110 Injection Costs",
        "payroll": false
    },
    "7162 Practice Manager/Administrator Compensation": {
        "id": 167,
        "value": "7162 Practice Manager/Administrator Compensation",
        "payroll": false
    },
    "7540 Housekeeping & Janitorial": {"id": 210, "value": "7540 Housekeeping & Janitorial", "payroll": false},
    "6000 Professional Services Costs:6095 Medical Waste Disposal Costs": {
        "id": 130,
        "value": "6000 Professional Services Costs:6095 Medical Waste Disposal Costs",
        "payroll": false
    },
    "7720 Other Tax": {"id": 228, "value": "7720 Other Tax", "payroll": true},
    "7300 Employee Benefit Program Expense:7302 S Corporation Shareholder Health Insurance Premium": {
        "id": 181,
        "value": "7300 Employee Benefit Program Expense:7302 S Corporation Shareholder Health Insurance Premium",
        "payroll": true
    },
    "7735 Business Gifts & Flowers": {"id": 231, "value": "7735 Business Gifts & Flowers", "payroll": false},
    "7785 Legal Services": {"id": 12, "value": "7785 Legal Services", "payroll": false},
    "7200 Employer Payroll Taxes Account Series Expenses:7220 Federal Unemployment Tax Expense": {
        "id": 174,
        "value": "7200 Employer Payroll Taxes Account Series Expenses:7220 Federal Unemployment Tax Expense",
        "payroll": false
    },
    "7360 Continuing Education Registration Expense:7363 Staff Training Fees and Costs": {
        "id": 191,
        "value": "7360 Continuing Education Registration Expense:7363 Staff Training Fees and Costs",
        "payroll": false
    },
    "7570 Repairs:7573 Facility Repairs": {"id": 214, "value": "7570 Repairs:7573 Facility Repairs", "payroll": false},
    "7590 Real Estate Tax": {"id": 215, "value": "7590 Real Estate Tax", "payroll": false},
    "9060 Officer/Key Person Life Insurance": {
        "id": 262,
        "value": "9060 Officer/Key Person Life Insurance",
        "payroll": false
    },
    "7808 Sponsored Events": {"id": 246, "value": "7808 Sponsored Events", "payroll": false},
    "6100 Pharmacy Costs:6115 FDA Prescription Flea/Tick Non-HW Parasite Control Product Costs": {
        "id": 134,
        "value": "6100 Pharmacy Costs:6115 FDA Prescription Flea/Tick Non-HW Parasite Control Product Costs",
        "payroll": false
    },
    "7510 Rent on Equipment": {"id": 201, "value": "7510 Rent on Equipment", "payroll": false},
    "7790 Business Consultation": {"id": 240, "value": "7790 Business Consultation", "payroll": false},
    "6100 Pharmacy Costs:6120 FDA Prescription HW or Combo HW/Parasite Control Product Costs": {
        "id": 135,
        "value": "6100 Pharmacy Costs:6120 FDA Prescription HW or Combo HW/Parasite Control Product Costs",
        "payroll": false
    },
    "7080 Associate Veterinarian Compensation:7081 Veterinarian Production Bonus": {
        "id": 286,
        "value": "7080 Associate Veterinarian Compensation:7081 Veterinarian Production Bonus",
        "payroll": false
    },
    "7200 Employer Payroll Taxes Account Series Expenses:7230 State Unemployment Tax Expense": {
        "id": 175,
        "value": "7200 Employer Payroll Taxes Account Series Expenses:7230 State Unemployment Tax Expense",
        "payroll": false
    },
    "7740 Charitable Contributions": {"id": 232, "value": "7740 Charitable Contributions", "payroll": false},
    "6400 Imaging Costs:6405 CT Costs": {"id": 143, "value": "6400 Imaging Costs:6405 CT Costs", "payroll": false},
    "6700 Dentistry Costs": {"id": 149, "value": "6700 Dentistry Costs", "payroll": false},
    "7140 Client Service Reps/Receptionists Compensation": {
        "id": 163,
        "value": "7140 Client Service Reps/Receptionists Compensation",
        "payroll": false
    },
    "6200 Dietary Product Costs": {"id": 26, "value": "6200 Dietary Product Costs", "payroll": false},
    "6300 Laboratory Costs": {"id": 16, "value": "6300 Laboratory Costs", "payroll": false},
    "7520 Maintenance": {"id": 18, "value": "7520 Maintenance", "payroll": false},
    "6400 Imaging Costs:6420 Specialist (Imaging) Consultation Costs": {
        "id": 146,
        "value": "6400 Imaging Costs:6420 Specialist (Imaging) Consultation Costs",
        "payroll": false
    },
    "7083 Relief Veterinarian - Contractor Payments": {
        "id": 157,
        "value": "7083 Relief Veterinarian - Contractor Payments",
        "payroll": false
    },
    "6400 Imaging Costs:6404 Dental X-Ray Costs": {
        "id": 142,
        "value": "6400 Imaging Costs:6404 Dental X-Ray Costs",
        "payroll": false
    },
    "9900 Ask My Accountant": {"id": 23, "value": "9900 Ask My Accountant", "payroll": false},
    "6200 Dietary Product Costs:6201 Therapeutic Diet Product Costs": {
        "id": 137,
        "value": "6200 Dietary Product Costs:6201 Therapeutic Diet Product Costs",
        "payroll": false
    },
    "6200 Dietary Product Costs:6202 Retail Diet Product Costs": {
        "id": 138,
        "value": "6200 Dietary Product Costs:6202 Retail Diet Product Costs",
        "payroll": false
    },
    "7730 Client Education Material": {"id": 230, "value": "7730 Client Education Material", "payroll": false},
    "7360 Continuing Education Registration Expense:7360 Business & Professional Book, Journals, VIN subscriptions": {
        "id": 190,
        "value": "7360 Continuing Education Registration Expense:7360 Business & Professional Book, Journals, VIN subscriptions",
        "payroll": false
    },
    "7570 Repairs:7571 Medical Equipment Repairs": {
        "id": 212,
        "value": "7570 Repairs:7571 Medical Equipment Repairs",
        "payroll": false
    },
    "6100 Pharmacy Costs:6130 Internet Pharmacy Costs": {
        "id": 136,
        "value": "6100 Pharmacy Costs:6130 Internet Pharmacy Costs",
        "payroll": false
    },
    "6300 Laboratory Costs:6301 In-House Lab Costs": {
        "id": 139,
        "value": "6300 Laboratory Costs:6301 In-House Lab Costs",
        "payroll": false
    },
    "7725 Veterinary & Professional Dues": {
        "id": 229,
        "value": "7725 Veterinary & Professional Dues",
        "payroll": false
    },
    "7750 Office Supplies": {"id": 15, "value": "7750 Office Supplies", "payroll": false},
    "7200 Employer Payroll Taxes Account Series Expenses:7210 FICA Tax Expense – Employer’s Portion": {
        "id": 173,
        "value": "7200 Employer Payroll Taxes Account Series Expenses:7210 FICA Tax Expense – Employer’s Portion",
        "payroll": false
    },
    "7670 Telephone Services:7671 Cellular Phone Service": {
        "id": 222,
        "value": "7670 Telephone Services:7671 Cellular Phone Service",
        "payroll": false
    },
    "6500 Surgery Costs": {"id": 147, "value": "6500 Surgery Costs", "payroll": false},
    "7660 Utilities:7662 Natural Gas/Fuel Oil/Propane Gas": {
        "id": 218,
        "value": "7660 Utilities:7662 Natural Gas/Fuel Oil/Propane Gas",
        "payroll": false
    },
    "7660 Utilities:7661 Electricity": {"id": 217, "value": "7660 Utilities:7661 Electricity", "payroll": false},
    "6400 Imaging Costs": {"id": 33, "value": "6400 Imaging Costs", "payroll": false},
    "6000 Professional Services Costs:6099 Exotic Animal Costs": {
        "id": 131,
        "value": "6000 Professional Services Costs:6099 Exotic Animal Costs",
        "payroll": false
    },
    "7570 Repairs:7572 IT and Office Equipment Repairs": {
        "id": 213,
        "value": "7570 Repairs:7572 IT and Office Equipment Repairs",
        "payroll": false
    },
    "7530 Service Contracts:7532 IT and Office Equipment Service Contracts": {
        "id": 208,
        "value": "7530 Service Contracts:7532 IT and Office Equipment Service Contracts",
        "payroll": false
    },
    "7807 Yellow Page Advertising": {"id": 6, "value": "7807 Yellow Page Advertising", "payroll": false},
    "7170 Groomers Compensation": {"id": 171, "value": "7170 Groomers Compensation", "payroll": false},
    "7745 Computer Supplies": {"id": 233, "value": "7745 Computer Supplies", "payroll": false},
    "7135 Veterinary/Technical Assistants Compensation": {
        "id": 162,
        "value": "7135 Veterinary/Technical Assistants Compensation",
        "payroll": false
    },
    "7775 Payroll Service Fees": {"id": 238, "value": "7775 Payroll Service Fees", "payroll": false},
    "7530 Service Contracts": {"id": 206, "value": "7530 Service Contracts", "payroll": false},
    "7530 Service Contracts:7533 Facility Service Contract": {
        "id": 209,
        "value": "7530 Service Contracts:7533 Facility Service Contract",
        "payroll": false
    },
    "7600 Personal Property Tax": {"id": 216, "value": "7600 Personal Property Tax", "payroll": false},
    "7360 Continuing Education Registration Expense": {
        "id": 188,
        "value": "7360 Continuing Education Registration Expense",
        "payroll": false
    },
    "7680 Answering Service": {"id": 225, "value": "7680 Answering Service", "payroll": false},
    "7530 Service Contracts:7531 Medical Equipment Service Contracts": {
        "id": 207,
        "value": "7530 Service Contracts:7531 Medical Equipment Service Contracts",
        "payroll": true
    },
    "7501 Other Rental Expense": {"id": 321, "value": "7501 Other Rental Expense", "payroll": false},
    "6800 Ancillary Products & Services Costs:6803 Non-FDA Flea/Tick Control Costs": {
        "id": 152,
        "value": "6800 Ancillary Products & Services Costs:6803 Non-FDA Flea/Tick Control Costs",
        "payroll": false
    },
    "7365 Travel & Lodging Expense:4366 Air Fare": {
        "id": 192,
        "value": "7365 Travel & Lodging Expense:4366 Air Fare",
        "payroll": false
    },
    "9009 Income Tax Expense Account Series:9200 State Income Tax Provision": {
        "id": 266,
        "value": "9009 Income Tax Expense Account Series:9200 State Income Tax Provision",
        "payroll": true
    },
    "6000 Professional Services Costs:Medical Equipment Supplies": {
        "id": 276,
        "value": "6000 Professional Services Costs:Medical Equipment Supplies",
        "payroll": false
    },
    "6100 Pharmacy Costs": {"id": 31, "value": "6100 Pharmacy Costs", "payroll": false},
    "7300 Employee Benefit Program Expense:7306 One-Person Stand-Alone HRA": {
        "id": 179,
        "value": "7300 Employee Benefit Program Expense:7306 One-Person Stand-Alone HRA",
        "payroll": false
    },
    "7620 Practice Vehicle Expenses": {"id": 7, "value": "7620 Practice Vehicle Expenses", "payroll": false},
    "7705 Licenses & Permits": {"id": 14, "value": "7705 Licenses & Permits", "payroll": false},
    "7175 Kennel Assistants Compensation": {
        "id": 172,
        "value": "7175 Kennel Assistants Compensation",
        "payroll": false
    },
    "7300 Employee Benefit Program Expense:7301 Group Health Insurance Premium Expense": {
        "id": 180,
        "value": "7300 Employee Benefit Program Expense:7301 Group Health Insurance Premium Expense",
        "payroll": false
    },
    "7360 Continuing Education Registration Expense:7361 Meeting/Course Registration Fees": {
        "id": 189,
        "value": "7360 Continuing Education Registration Expense:7361 Meeting/Course Registration Fees",
        "payroll": false
    },
    "7675 Cable & Internet Services": {"id": 224, "value": "7675 Cable & Internet Services", "payroll": false},
    "6000 Professional Services Costs:6025 Fluid Therapy Costs": {
        "id": 127,
        "value": "6000 Professional Services Costs:6025 Fluid Therapy Costs",
        "payroll": false
    },
    "7806 Memorial Contributions": {"id": 245, "value": "7806 Memorial Contributions", "payroll": false},
    "7660 Utilities:7663 Sewer": {"id": 219, "value": "7660 Utilities:7663 Sewer", "payroll": false},
    "7710 Use Tax Paid": {"id": 20, "value": "7710 Use Tax Paid", "payroll": false},
    "6000 Professional Services Costs:6020 Examination, Hospitalization & Treatment Costs": {
        "id": 126,
        "value": "6000 Professional Services Costs:6020 Examination, Hospitalization & Treatment Costs",
        "payroll": false
    },
    "7910 Credit Card Merchant Service Fees": {
        "id": 249,
        "value": "7910 Credit Card Merchant Service Fees",
        "payroll": false
    },
    "6300 Laboratory Costs:6303 ECG / BP Specialist Review": {
        "id": 279,
        "value": "6300 Laboratory Costs:6303 ECG / BP Specialist Review",
        "payroll": false
    },
    "7905 Bank Charges and Service Fees": {"id": 8, "value": "7905 Bank Charges and Service Fees", "payroll": false},
    "9070 Officer Disability Insurance": {"id": 263, "value": "9070 Officer Disability Insurance", "payroll": false},
    "7000 Owner Veterinarian Compensation": {
        "id": 9,
        "value": "7000 Owner Veterinarian Compensation",
        "payroll": false
    },
    "7168 Clerical/Secretarial Personnel Compensation": {
        "id": 170,
        "value": "7168 Clerical/Secretarial Personnel Compensation",
        "payroll": false
    },
    "7930 Bad Debts": {"id": 252, "value": "7930 Bad Debts", "payroll": false},
    "6400 Imaging Costs:6415 MRI Costs": {"id": 145, "value": "6400 Imaging Costs:6415 MRI Costs", "payroll": false},
    "7445 Staff Events & Recreation": {"id": 197, "value": "7445 Staff Events & Recreation", "payroll": false},
    "7090 Intern Veterinarians Compensation": {
        "id": 159,
        "value": "7090 Intern Veterinarians Compensation",
        "payroll": false
    },
    "Unapplied Cash Bill Payment Expense": {
        "id": 284,
        "value": "Unapplied Cash Bill Payment Expense",
        "payroll": false
    },
    "7080 Associate Veterinarian Compensation": {
        "id": 156,
        "value": "7080 Associate Veterinarian Compensation",
        "payroll": false
    },
    "7502 Lease Abandonment Costs": {"id": 322, "value": "7502 Lease Abandonment Costs", "payroll": false},
    "6850 Grooming Costs": {"id": 155, "value": "6850 Grooming Costs", "payroll": false},
    "7200 Employer Payroll Taxes Account Series Expenses:7250 Other Employer Payroll Tax Expense": {
        "id": 176,
        "value": "7200 Employer Payroll Taxes Account Series Expenses:7250 Other Employer Payroll Tax Expense",
        "payroll": false
    },
    "7915 Care Credit Service Fees": {"id": 250, "value": "7915 Care Credit Service Fees", "payroll": false},
    "6000 Professional Services Costs:6050 Animal Disposal/Mortuary Costs": {
        "id": 129,
        "value": "6000 Professional Services Costs:6050 Animal Disposal/Mortuary Costs",
        "payroll": false
    },
    "6800 Ancillary Products & Services Costs:6802 Pet Supply Costs": {
        "id": 151,
        "value": "6800 Ancillary Products & Services Costs:6802 Pet Supply Costs",
        "payroll": false
    },
    "7365 Travel & Lodging Expense:7369 Mileage Reimbursement (CE Travel)": {
        "id": 195,
        "value": "7365 Travel & Lodging Expense:7369 Mileage Reimbursement (CE Travel)",
        "payroll": false
    },
    "7520 Maintenance:7523 Facility Maintenance": {
        "id": 205,
        "value": "7520 Maintenance:7523 Facility Maintenance",
        "payroll": false
    },
    "7580 Property, Casualty, & Liability Insurance": {
        "id": 10,
        "value": "7580 Property, Casualty, & Liability Insurance",
        "payroll": false
    },
    "6400 Imaging Costs:6403 X-Ray Costs": {
        "id": 141,
        "value": "6400 Imaging Costs:6403 X-Ray Costs",
        "payroll": false
    },
    "7164 Office Manager/Executive Assistant Compensation": {
        "id": 168,
        "value": "7164 Office Manager/Executive Assistant Compensation",
        "payroll": false
    },
    "7570 Repairs": {"id": 211, "value": "7570 Repairs", "payroll": false},
    "6800 Ancillary Products & Services Costs": {
        "id": 28,
        "value": "6800 Ancillary Products & Services Costs",
        "payroll": false
    },
    "6400 Imaging Costs:6410 Ultrasound Costs": {
        "id": 144,
        "value": "6400 Imaging Costs:6410 Ultrasound Costs",
        "payroll": false
    },
    "6000 Professional Services Costs:6040 Rehabilitation Costs": {
        "id": 128,
        "value": "6000 Professional Services Costs:6040 Rehabilitation Costs",
        "payroll": false
    },
    "7760 Printing": {"id": 235, "value": "7760 Printing", "payroll": false},
    "7460 Laundry & Uniform": {"id": 199, "value": "7460 Laundry & Uniform", "payroll": false},
    "7802 Website Maintenance": {"id": 241, "value": "7802 Website Maintenance", "payroll": false},
    "7440 Business Meals": {"id": 13, "value": "7440 Business Meals", "payroll": false},
    "9009 Income Tax Expense Account Series:9100 Federal Income Tax Provision": {
        "id": 265,
        "value": "9009 Income Tax Expense Account Series:9100 Federal Income Tax Provision",
        "payroll": false
    },
    "7145 Other (Non-DVM) Temporary Services - Contractor Payments": {
        "id": 164,
        "value": "7145 Other (Non-DVM) Temporary Services - Contractor Payments",
        "payroll": false
    },
    "7940 Returned Check Fees": {"id": 253, "value": "7940 Returned Check Fees", "payroll": false},
    "9009 Income Tax Expense Account Series:9300 Local Income Tax Provision": {
        "id": 267,
        "value": "9009 Income Tax Expense Account Series:9300 Local Income Tax Provision",
        "payroll": false
    },
    "7520 Maintenance:7521 Medical Equipment Maintenance": {
        "id": 203,
        "value": "7520 Maintenance:7521 Medical Equipment Maintenance",
        "payroll": false
    },
    "7160 Administrative Personnel Compensation": {
        "id": 166,
        "value": "7160 Administrative Personnel Compensation",
        "payroll": false
    },
    "7340 Workers Compensation Premium/Tax Expense": {
        "id": 187,
        "value": "7340 Workers Compensation Premium/Tax Expense",
        "payroll": false
    },
    "6800 Ancillary Products & Services Costs:6804 Internet Ancillary Retail Sales Costs": {
        "id": 153,
        "value": "6800 Ancillary Products & Services Costs:6804 Internet Ancillary Retail Sales Costs",
        "payroll": false
    },
    "7300 Employee Benefit Program Expense:7303 Group Dental Insurance Premium Expense": {
        "id": 182,
        "value": "7300 Employee Benefit Program Expense:7303 Group Dental Insurance Premium Expense",
        "payroll": false
    },
    "6300 Laboratory Costs:6302 Outside (Reference) Lab Costs": {
        "id": 140,
        "value": "6300 Laboratory Costs:6302 Outside (Reference) Lab Costs",
        "payroll": false
    },
    "7100 Other Support Staff Compensation": {
        "id": 160,
        "value": "7100 Other Support Staff Compensation",
        "payroll": false
    },
    "9050 Fines & Penalties": {"id": 261, "value": "9050 Fines & Penalties", "payroll": false},
    "7670 Telephone Services": {"id": 221, "value": "7670 Telephone Services", "payroll": false},
    "7150 Maintenance Personnel Compensation": {
        "id": 165,
        "value": "7150 Maintenance Personnel Compensation",
        "payroll": false
    },
    "7365 Travel & Lodging Expense:7367 Lodging": {
        "id": 193,
        "value": "7365 Travel & Lodging Expense:7367 Lodging",
        "payroll": false
    },
    "7670 Telephone Services:7672 Landline Phone Service": {
        "id": 223,
        "value": "7670 Telephone Services:7672 Landline Phone Service",
        "payroll": false
    },
    "Cost of Goods Sold": {"id": 269, "value": "Cost of Goods Sold", "payroll": false},
    "7920 Collection Fees": {"id": 251, "value": "7920 Collection Fees", "payroll": false},
    "6100 Pharmacy Costs:6105 FDA Prescription Meds, PIll, Cap, Liquid, Etc. Costs": {
        "id": 132,
        "value": "6100 Pharmacy Costs:6105 FDA Prescription Meds, PIll, Cap, Liquid, Etc. Costs",
        "payroll": false
    },
    "7005 Owner Management Compensation": {"id": 3, "value": "7005 Owner Management Compensation", "payroll": false},
    "7803 Internet Advertising": {"id": 242, "value": "7803 Internet Advertising", "payroll": false},
    "9080 Interest Expense": {"id": 11, "value": "9080 Interest Expense", "payroll": false},
    "7810 Advertising & Promotion - Other": {
        "id": 248,
        "value": "7810 Advertising & Promotion - Other",
        "payroll": false
    },
    "7470 Employment Practices Liability Insurance": {
        "id": 200,
        "value": "7470 Employment Practices Liability Insurance",
        "payroll": false
    }
};

